"use client"

import { QuestionMarkCircleIcon } from "@heroicons/react/20/solid"
import Switch from "@src/components/Switch"
import { useConfidentialMode } from "@src/providers/ConfidentialModeProvider"

const ConfidentialToggleDesktop = () => {
  const {
    confidentialMode,
    setConfidentialMode,
    isAuthenticating,
    isConnected,
    openModal,
  } = useConfidentialMode()

  return (
    <div className="flex items-center justify-between gap-4 px-3.5 py-3.5">
      <div className="flex items-center gap-2">
        <div className="flex-1 font-semibold confidential:text-gray-300 text-gray-700 text-sm transition-colors duration-200">
          Confidential mode
        </div>
        <button
          type="button"
          className="-m-1 flex items-center justify-center rounded-lg p-1 text-gray-400 confidential:hover:text-gray-200 hover:text-gray-600"
          onClick={openModal}
        >
          <span className="sr-only">What’s this?</span>
          <QuestionMarkCircleIcon className="size-5" />
        </button>
      </div>

      <div className="shrink-0">
        <Switch
          checked={confidentialMode}
          onCheckedChange={setConfidentialMode}
          disabled={!isConnected}
          isLoading={isAuthenticating}
          aria-label="Toggle Confidential mode"
        />
      </div>
    </div>
  )
}

export default ConfidentialToggleDesktop
